import ExpandMore from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { noop } from 'lodash-es';
import { PropsWithChildren, ReactNode, useCallback } from 'react';

import { Sxable } from 'library/types';

import { Accordion, AccordionSummary } from './Accordion';
import { useAccordion } from './useAccordion';

export const AccordionItem = ({
	accordionName,
	header,
	HeaderComponent,
	children,
	onChange = noop,
	sx = {},
}: PropsWithChildren<{
	accordionName: string;
	header?: string;
	HeaderComponent?: ReactNode;
	onChange?: (name: string, isExpanded: boolean) => void;
}> &
	Sxable) => {
	const {
		expanded,
		checkIfExpanded,
		onChange: onAccordionChange,
	} = useAccordion();
	const {
		palette: {
			gray: { main },
		},
	} = useTheme();

	const handleOnChange = useCallback(() => {
		onAccordionChange(accordionName);
		onChange(accordionName, expanded?.includes(accordionName) || false);
	}, [accordionName, expanded, onAccordionChange, onChange]);

	return (
		<Accordion
			id={accordionName}
			sx={[
				{
					'&.Mui-expanded': { background: 'white' },
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			expanded={checkIfExpanded(accordionName)}
			onChange={handleOnChange}>
			<AccordionSummary
				sx={{ '&:hover': { background: main } }}
				expandIcon={<ExpandMore />}>
				{HeaderComponent
					? HeaderComponent
					: header && <Typography>{header}</Typography>}
			</AccordionSummary>
			{expanded?.includes(accordionName) && (
				<AccordionDetails>{children}</AccordionDetails>
			)}
		</Accordion>
	);
};
